import { useState } from "react";

const SingleGradeStep = ({gradeStep, editStep, deleteStep}) => {
    const [title, setTitle] = useState(gradeStep?.title);
    const [body, setBody] = useState(gradeStep?.body);
    const [order, setOrder] = useState(gradeStep?.order);
    const [baseGrade, setBaseGrade] = useState(gradeStep?.baseGrade);
    const [isEdit, setIsEdit] = useState(false);
    const editStepEvent = () => {
        if(isEdit && title && baseGrade) {
            const updatedStep = {
                ...gradeStep,
                title,
                body,
                order: parseInt(order),
                baseGrade: parseInt(baseGrade)
            };
            editStep(updatedStep);
            setIsEdit(false);
        }
       
    }
    const deleteStepEvent = () => {
        if (window.confirm("Are you sure you want to delete this step?")) {
            deleteStep(gradeStep);
        }
    }
  return (
    <div>
        <div className="flex items-center justify-between border-b border-gray-800 gap-2 p-2">
            <h3 className="text-lg font-semibold w-10   " > {gradeStep.baseGrade}%  </h3>
            <h3 className="text-lg font-semibold flex-1  " > - {gradeStep?.title}  </h3>
            <span className="text-gray-500 text-sm">{gradeStep.order}</span> 
            <span className="text-gray-500 text-sm">{gradeStep._id}</span>
            {!isEdit && (
            <div className="flex items-center gap-2">
 <button
            onClick={() => setIsEdit(true)}
            className="text-blue-500 hover:underline"
            >
        עריכה   
            </button>
             <button
            onClick={deleteStepEvent}
            className="text-blue-500 hover:underline"
            >
        מחיקה   
            </button>
            </div>)}
           
        </div>
        {isEdit && (
            <div className="mt-2 d-flex flex-row gap-2">
            <span>%</span>
             <input
                title="Grade"
                type="number"
                value={baseGrade}
                onChange={(e) => setBaseGrade(e.target.value)}
                className="border p-1 w-20 mb-2"
                placeholder="Grade"
            />
            <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="border p-1 flex-1 mb-2"
                placeholder="Title"
            />
            {/* <textarea
                value={body}
                onChange={(e) => setBody(e.target.value)}
                className="border p-1 w-full mb-2"
                placeholder="Description"
            /> */}
           
            <input
                title="Order"
                type="number"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
                className="border p-1 w-16 mb-2"
                placeholder="Order"
            />
             <button
            onClick={editStepEvent}
            className={`text-blue-500  hover:underline ${!title || !baseGrade ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={!title || !baseGrade}
            >
           שמור שינויים
            </button>
             <button
            onClick={() => setIsEdit(false)}
            className="text-blue-500 hover:underline"
            >
          ביטול
            </button>
            </div>
        ) }    </div>
  )
}

export default SingleGradeStep